import { Outlet } from "react-router-dom";
import RatingDocumentHeader from "./RatingHeader";

const Rating = () => {
  return (
    <>
      <RatingDocumentHeader />
      <Outlet />
    </>
  );
};

export default Rating;
